import React from 'react';
import ReactDOM from 'react-dom/client';
import AppWrapper from './App';
import 'bootstrap-icons/font/bootstrap-icons.css';
// En tu index.js
if ('serviceWorker' in navigator) {
  // Cuando un SW nuevo toma control (tras un deploy), recargar una sola vez
  // para que la pestaña/TWA cargue el bundle nuevo sin depender de reinstalar.
  // Solo si la página ya estaba controlada por un SW anterior (no en la primera instalación),
  // nunca en desarrollo, y como máximo una vez cada 30 s para evitar loops de recarga.
  const SW_RELOAD_KEY = 'swReloadedAt';
  const hadController = !!navigator.serviceWorker.controller;
  let refreshingAfterSwUpdate = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshingAfterSwUpdate || !hadController || process.env.NODE_ENV !== 'production') return;
    let lastReload = 0;
    try {
      lastReload = Number(sessionStorage.getItem(SW_RELOAD_KEY)) || 0;
    } catch {}
    if (Date.now() - lastReload < 30000) return;
    try {
      sessionStorage.setItem(SW_RELOAD_KEY, String(Date.now()));
    } catch {}
    refreshingAfterSwUpdate = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    // Usar la ruta absoluta a la raíz
    navigator.serviceWorker.register('/service-worker.js')
      .catch(err => console.error('Error al registrar SW:', err));
  });
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>
);